<ng-container *transloco="let t; prefix: scope()">
  <a
    class="rounded-3xl bg-transparent px-4 py-1 font-normal text-steel-100 transition-colors duration-500 ease-out hover:bg-blue-10"
    routerLink="/profile/login"
    >{{ t('login') }}</a
  >
  <a
    class="rounded-3xl bg-blue-50 px-4 py-1 font-normal text-white transition-colors hover:opacity-80"
    routerLink="/account/join"
    data-id="join-rma-button"
    rel="nofollow"
    >{{ t('join') }}</a
  >
</ng-container>
